/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanAddDeferredIncomeRequestDto
 */
export interface MonthPlanAddDeferredIncomeRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanAddDeferredIncomeRequestDto
   */
  deferredIncomeId: string;
}

export function MonthPlanAddDeferredIncomeRequestDtoFromJSON(json: any): MonthPlanAddDeferredIncomeRequestDto {
  return MonthPlanAddDeferredIncomeRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanAddDeferredIncomeRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanAddDeferredIncomeRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    deferredIncomeId: json["deferredIncomeId"],
  };
}

export function MonthPlanAddDeferredIncomeRequestDtoToJSON(value?: MonthPlanAddDeferredIncomeRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    deferredIncomeId: value.deferredIncomeId,
  };
}
